import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';

import { config as withConfig} from './config';
import AppNav from './components/AppNav';
import RenderDialogs from './components/Dialogs';
import AppRoutes from './AppRoutes';

function App () {
    return (
        <>
            <CssBaseline />
            <RenderDialogs />

            <AppNav />
            <AppRoutes />
        </>
    );
}

export default withConfig(App);
